import React from 'react';
import Select from 'react-select';

import { DropdownIndicator, style } from './select-customizations';

type MultiSelectProps = {
  placeholder;
  components?;
  onChange;
  className;
  classNamePrefix;
  defaultValue?;
  value?;
  options;
  disabled?: boolean;
  isLoading?: boolean;
  isOptionDisabled?: (option: any) => boolean;
  closeMenuOnSelect?: boolean;
  hideSelectedOptions?: boolean;
};

const MultiSelect: React.FC<MultiSelectProps> = ({
  placeholder,
  onChange,
  className,
  classNamePrefix,
  defaultValue,
  value,
  options,
  components,
  disabled = false,
  isLoading = false,
  isOptionDisabled,
  closeMenuOnSelect,
  hideSelectedOptions,
}) => (
  <Select
    placeholder={placeholder}
    components={{ DropdownIndicator, ...components }}
    styles={style}
    isMulti
    options={options}
    {...(value !== undefined
      ? { value }
      : { defaultValue })}
    onChange={onChange}
    className={className}
    classNamePrefix={classNamePrefix}
    isDisabled={disabled}
    isLoading={isLoading}
    isOptionDisabled={isOptionDisabled}
    {...(closeMenuOnSelect !== undefined && { closeMenuOnSelect })}
    {...(hideSelectedOptions !== undefined && { hideSelectedOptions })}
  />
);

export default MultiSelect;
